/* eslint-disable */
export default {
  noActiveCalls: 'No active calls',
  noCalls: 'No results found.',
  currentCall: 'Current Call',
  ringCall: 'Ringing call',
  onHoldCall: 'Call on Hold',
  historyCalls: 'Past calls',
  otherDeviceCall: 'Ongoing calls on my other devices',
  searchPlaceholder: 'Search...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
